import { render, staticRenderFns } from "./PopupBoardList.vue?vue&type=template&id=5f028292"
import script from "./PopupBoardList.vue?vue&type=script&lang=js"
export * from "./PopupBoardList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports